/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  gap: 20px;
`;
Container.displayName = 'Container';

export const CVEContainer = styled.div`
`;
CVEContainer.displayName = 'CVEContainer';

export const Title = styled.div`
    font-size: 12.5px;
    font-weight: 500;
    line-height: 2.08;
    color: ${({ theme }) => theme.text.modalLabel};
    font-weight: 600;
    margin-bottom: 12px;
`;
Title.displayName = 'Title';
